import React from 'react'

const SweepGroupLimitList = ({itemData,itemKey,data,glsAgent,pageJson,translations,translateWordForOption, accountCountryList,getCountryTaxonomy}) => {
  const item = data.filter(item => item.id === itemData)[0]

  if(item !== undefined){
    return(
      <div className="sweep-instructions-wrapper">
        <div className="sweep-instruction" style={{background: '#fff'}}>
          <div className="sweep-instruction__sweep-details">
            <label className="sweep-instruction__sweep-details__sweep-name read-only-list">
              {`${item.sweepId}`}
              <span>{`(${item.ccrBilateralLimits.currency})`}</span>
              <i className="icon icon-chevron-right"></i>
            </label>
            <p className="sweep-instruction__sweep-details__sweep-type">
              {`${item.sweepParticipantsAccounts !== undefined ? item.sweepParticipantsAccounts.sweepType.name : ''}, ${'accountRegion' in item.sweepParticipantsAccounts && item.sweepParticipantsAccounts !== undefined ? item.sweepParticipantsAccounts.accountRegion : ''}`}
            </p>
          </div>
          <div className="master-account-details sweep-instruction-account-section">
            <label className="master-account-details__header">{translations(pageJson.master)}</label>
            <p className="master-account-details__account-name">
            {`${item.sweepParticipantsAccounts !== undefined && item.sweepParticipantsAccounts.masterAccountData !== undefined && item.sweepParticipantsAccounts.masterAccountData.accountType !== undefined ? accountCountryList !== undefined
                ? getCountryTaxonomy(item.sweepParticipantsAccounts.masterAccountData).accountType.name+ ',' :item.sweepParticipantsAccounts.masterAccountData.accountType.name + ',' : ''}
              ${item.sweepParticipantsAccounts !== undefined && item.sweepParticipantsAccounts.masterAccountData !== undefined && item.sweepParticipantsAccounts.masterAccountData.accountNumber !== undefined ? item.sweepParticipantsAccounts.masterAccountData.accountNumber + ',' : ''}
              ${item.sweepParticipantsAccounts !== undefined && item.sweepParticipantsAccounts.masterAccountData !== undefined && item.sweepParticipantsAccounts.masterAccountData.branchCode !== undefined ? item.sweepParticipantsAccounts.masterAccountData.branchCode + ',' : ''}
              ${item.sweepParticipantsAccounts !== undefined && item.sweepParticipantsAccounts.masterAccountData !== undefined && item.sweepParticipantsAccounts.masterAccountData.country !== undefined ? accountCountryList !== undefined
                ? getCountryTaxonomy(item.sweepParticipantsAccounts.masterAccountData).country.name+ ',' :item.sweepParticipantsAccounts.masterAccountData.country.name + ',' : ''}
              ${item.sweepParticipantsAccounts !== undefined && item.sweepParticipantsAccounts.masterAccountData !== undefined && item.sweepParticipantsAccounts.masterAccountData.currency !== undefined ? item.sweepParticipantsAccounts.masterAccountData.currency.name : ''}`}
            </p>
            <p className="master-account-details__others">{glsAgent.name}</p>
            <p className="master-account-details__others"></p>
          </div>
          <div className="sub-account-details sweep-instruction-account-section">
            <label className="sub-account-details__header">{translations(pageJson.sub)}</label>
            <p className="sub-account-details__account-name">
            {`${item.sweepParticipantsAccounts !== undefined && item.sweepParticipantsAccounts.subAccountData !== undefined && item.sweepParticipantsAccounts.subAccountData.accountType !== undefined ? accountCountryList !== undefined
                ? getCountryTaxonomy(item.sweepParticipantsAccounts.subAccountData).accountType.name+ ',' :item.sweepParticipantsAccounts.subAccountData.accountType.name + ',' : ''}
              ${item.sweepParticipantsAccounts !== undefined && item.sweepParticipantsAccounts.subAccountData !== undefined && item.sweepParticipantsAccounts.subAccountData.accountNumber !== undefined ? item.sweepParticipantsAccounts.subAccountData.accountNumber + ',' : ''}
              ${item.sweepParticipantsAccounts !== undefined && item.sweepParticipantsAccounts.subAccountData !== undefined && item.sweepParticipantsAccounts.subAccountData.branchCode !== undefined ? item.sweepParticipantsAccounts.subAccountData.branchCode + ',' : ''}
              ${item.sweepParticipantsAccounts !== undefined && item.sweepParticipantsAccounts.subAccountData !== undefined && item.sweepParticipantsAccounts.subAccountData.country !== undefined ? accountCountryList !== undefined
                ? getCountryTaxonomy(item.sweepParticipantsAccounts.subAccountData).country.name+ ',' :item.sweepParticipantsAccounts.subAccountData.country.name + ',' : ''}
              ${item.sweepParticipantsAccounts !== undefined && item.sweepParticipantsAccounts.subAccountData !== undefined && item.sweepParticipantsAccounts.subAccountData.currency !== undefined ? item.sweepParticipantsAccounts.subAccountData.currency.name : ''}`}
            </p>
            <p className="sub-account-details__others">{glsAgent.name}</p>
            <p className="sub-account-details__others"></p>
          </div>
        </div>
      </div>
    )
  }else {
    return null
  }
}


const SweepGroupLimit = (props) => (
  <div className="cc-detail-section clearfix">
    <div className="cc-detail-section__heading">{`5. ${props.translations(props.pageJson.pageHeading)}`}</div>
      <div className="gdocs-mleft-25">
        <dl style={{display: 'flex'}}>
          <dd>{props.translations(props.pageJson.textDefineSweepGroups)}</dd>
          <dt className="gdocs-mleft-30">{props.data !== undefined && props.data.cashConcentration !== undefined ? props.data.cashConcentration.sweepGroups === true ? 'Yes' : 'No' :''}</dt>
        </dl>
      </div>
    {
      (props.data !== undefined && props.data.cashConcentration !== undefined) ? props.data.cashConcentration.sweepGroups === true && props.data.cashConcentration.sweepGroupsLimits.length > 0 && props.data.cashConcentration.sweepGroupsLimits.map((item,key) => (
        <div className="cc-detail-section__content" key={key}>
          <div className="cc-detail-section__content__heading">{`${item.sweepGroupId} 00${key+1}`}</div>
          <dl className="cc-detail-section__content__list">
            <dt>{props.translations(props.pageJson.setICSLimit)}</dt>
            <dd>{item.icsLimit === true ? 'Yes' : 'No'}</dd>
            <dt>{props.translations(props.pageJson.limitType)}</dt>
            <dd>{props.translations(props.pageJson.grpFacilityLimit)}</dd>
            <dt>{props.translations(props.pageJson.currency)}</dt>
            {
	            item.currency !== undefined
            	? <dd>{item.currency.name}</dd>
            	: <dd>&nbsp;</dd>
            }
            <dt>{props.translations(props.pageJson.limit)}</dt>
            <dd>{'limit' in item ? item.limit : 'N/A'}</dd>
            <dt>{props.translations(props.pageJson.limitBreach)}</dt>
            {
	            item.limitBreachAction !== undefined
            	? <dd>{item.limitBreachAction.name}</dd>
            	: <dd>&nbsp;</dd>
            }
          </dl>
          <hr />
          <div className="cc-detail-section__content__heading">{props.translations(props.pageJson.sweepInstructions)}</div>
          {
            'sweepInstructions' in item && item.sweepInstructions.length > 0 && item.sweepInstructions.map((item,key) =>
              <SweepGroupLimitList
                itemData={item}
                itemKey={key}
                data={props.data.cashConcentration.sweepInstructions}
                glsAgent={props.data.glsAgent}
                pageJson={props.pageJson}
                translations={props.translations}
                translateWordForOption={props.translateWordForOption}
              />)
          }
        </div>
      )):''
    }
  </div>
)

export default SweepGroupLimit;



// WEBPACK FOOTER //
// ./src/components/CaseList/PreviewGLS/CCPreview/SweepGroupLimit.js